// extracted by mini-css-extract-plugin
module.exports = {"day_use_booking_view_wrapper":"BookedDayUseView_day_use_booking_view_wrapper__1s92w","day_use_icon":"BookedDayUseView_day_use_icon__2Cccy"};